import axios from 'axios'
import { Url } from './constantUrl'
import getHeaders from './getHeaders'
import * as types from './types'
import { errorHandler } from './error/errorHandler.action'
import { notify } from '../services/notification';
import getHeadersformdata from './getHeaderFormdata'
import { pageValue } from '../constants/constant'

//NotificationList_detail

export const notificationlistdetailAction = (page, value, criteria) => dispatch => {
  if (value) {
    var url =process.env.REACT_APP_API_URL +Url.NOTIFICATION_LIST +`?page=${page}&page_size=10` +"&"+`${criteria}=${value}`;
  } else {
    var url =process.env.REACT_APP_API_URL+Url.NOTIFICATION_LIST+`?page=${page}&page_size=10`;

  }
  let options = Object.assign({ method: 'GET' })
  options.headers = getHeaders()
  options.url = url
  return axios(options).then(resp => {
    if (resp.status === 200 || resp.status === 201) {

      dispatch({ type: types.GET_NOTIFICATOIN_DETAIL_LIST, payload: resp })
      return resp
    } else { return null }
  })
    .catch(error => {
      errorHandler(error)
    })
}

// Notification Searched Data
export const notificationsearchAction =
  (params = {}) =>
  (dispatch) => {
    dispatch({
      type: types.SEARCH_NOTIFICATION,
      payload: params ? { data: params } : null,
    });
  };

 // Notification Page Data
 export const notificationpageAction =
  (params = {}) =>
  (dispatch) => {
    dispatch({
      type: types.PAGE_NOTIFICATION,
      payload: params ?  params : null,
    });
  };



//Notification_detail BY ID

export const notificationdetailByIdAction = (parm) => dispatch => {
  const url = process.env.REACT_APP_API_URL + Url.NOTIFICATION_DETAIL +"?id="+parm
  let options = Object.assign({ method: 'GET' })
  options.headers = getHeaders()
  options.url = url
  return axios(options).then(resp => {
    if (resp.status === 200 || resp.status === 201) {
      dispatch({ type: types.GET_NOTIFICATOIN_DETAIL, payload: resp })
      return resp
    } else { return null }
  })
    .catch(error => {
      errorHandler(error)
    })
}
//Create Notification

export const postCreateNotification = (params) => dispatch => {
  const url = process.env.REACT_APP_API_URL + Url. CREATE_NOTIFICATION
  let options = Object.assign({ method: 'POST' }, params ? { data: params } : null)
  options.headers = getHeaders()
  options.url = url
  return axios(options).then(resp => {
    if (resp.status === 200 || resp.status === 201) {

       dispatch({ type: types.POST_CREATE_NOTIFICATION, payload: resp })
      return resp
    } else { return null }
  }).catch(error => {
    if (error?.response?.status === 400) {
      return notify.error(error.response.data.message.non_field_errors || error.response.data.message?.minimum_redemption_amount
      )
      
    }
  })
}

export const postCreateNotificationExcel = (params) => dispatch => {
  const url = process.env.REACT_APP_API_URL + Url. CREATE_NOTIFICATION_EXCEL
  let options = Object.assign({ method: 'POST' }, params ? { data: params } : null)
  options.headers = getHeadersformdata()
  options.url = url
  return axios(options).then(resp => {
    if (resp.status === 200 || resp.status === 201) {

       dispatch({ type: types.POST_CREATE_NOTIFICATION_EXCEL, payload: resp })
      return resp
    } else { return null }
  }).catch(error => {
    if (error?.response?.status === 400) {
      if (error.response?.data?.Message) {
        notify.error(error.response.data.Message);
      }
      if (error.response?.data?.error) {
        notify.error(error.response.data.error);
      }
      if (error.response?.data?.message?.title) {
        notify.error(error.response.data.message.title);
      }
      if (error.response?.data?.message?.body) {
        notify.error(error.response.data.message.body);
      }
    }
    else{
      if (error.response?.data?.Message) {
        notify.error(error.response.data.Message);
      }
    }
  })
  
}

  //Update notification

  export const updateNotificationAction = (params = {},id) => dispatch => {
    const url = process.env.REACT_APP_API_URL + Url.UPDATE_NOTIFICATION +"/"+id
    let options = Object.assign({ method: 'PUT' }, params ? { data: params } : null)
    options.headers = getHeaders()
    options.url = url
    return axios(options).then(resp => {
      if (resp.status === 200 || resp.status === 201) {
        dispatch({ type: types.POST_UPDATE_NOTIFICATION, payload: resp })
        return resp
      } else { return null }
    }).catch(error => {
      if (error?.response?.status === 400) {
        return error.response.data.message.non_field_errors
        || error.response.data.message?.minimum_redemption_amount
      }
    })
  }

  // State List For Create Notification

  export const stateListAction = () => dispatch => {
    const url = process.env.REACT_APP_API_URL + Url.STATE_LIST
    +`?page=1&page_size=${pageValue.statePageSize}`
    let options = Object.assign({ method: 'GET' })
    options.headers = getHeaders()
    options.url = url
    return axios(options).then(resp => {
      if (resp.status === 200 || resp.status === 201) {
        dispatch({ type: types.GET_STATE_LIST, payload: resp })
        return resp
      } else { return null }
    })
      .catch(error => {
        errorHandler(error)
      })
  }

  // District List For Create Notification

  export const districtListAction = (parm) => dispatch => {
    const url = (
      parm
      ? process.env.REACT_APP_API_URL + Url.DISTRICT_LIST +"?"+`state_id=${parm}`
      : process.env.REACT_APP_API_URL + Url.DISTRICT_LIST
    );
    
    //  +`?page=1&page_size=10` 
    let options = Object.assign({ method: 'GET' })
    options.headers = getHeaders()
    options.url = url
    return axios(options).then(resp => {
      if (resp.status === 200 || resp.status === 201) {
        dispatch({ type: types.GET_DISTRICT_LIST, payload: resp })
        return resp
      } else { return null }
    })
      .catch(error => {
        errorHandler(error)
      })
  }

    // User group List For Create Notification

    export const usergroupListAction = () => dispatch => {
      const url = process.env.REACT_APP_API_URL + Url.USER_GROUPS
      let options = Object.assign({ method: 'GET' })
      options.headers = getHeaders()
      options.url = url
      return axios(options).then(resp => {
        if (resp.status === 200 || resp.status === 201) {
          dispatch({ type: types.GET_USER_GROUPS, payload: resp })
          return resp
        } else { return null }
      })
        .catch(error => {
          errorHandler(error)
        })
    }

      // Redirection page List For Create Notification

  export const RedirectionPageListAction = () => dispatch => {
    const url = process.env.REACT_APP_API_URL + Url.REDIRECTION_PAGE
    let options = Object.assign({ method: 'GET' })
    options.headers = getHeaders()
    options.url = url
    return axios(options).then(resp => {
      if (resp.status === 200 || resp.status === 201) {
        dispatch({ type: types.GET_REDIRECTION_PAGE_LIST, payload: resp })
        return resp
      } else { return null }
    })
      .catch(error => {
        errorHandler(error)
      })
  }